module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-no"
  }, [_vm._v("Day 1")]), _vm._v(" "), _c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("You Are on a Mission from God")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("For we are His workmanship, created in Christ Jesus for good works, which God prepared beforehand that we should walk in them.")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Ephesians 2:10")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I (Tim Hill) was seven years old, I was sitting between my mom and dad in the back of the Texas Church of God tabernacle in Weatherford, TX in a camp meeting on a Sunday night. I had just started singing a little bit at my dad’s church in Fort Worth. Someone in leadership had heard about it and had the idea to have me sing that night. The man in charge of the music came back to the back of that auditorium. He picked me up from between my parents, raced me down to the stage. He pulled a piano bench out. He stood me on top of it, put a microphone in front of my face and said: “Sing, boy.” There I was, seven years old, standing on top of a piano bench in front of 800 people on a Sunday night, about to sing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only thing I could think to sing was a song my mom had been playing over and over on the old record player back at home . . . "), _c('i', [_vm._v("I Wouldn’t Take Nothing For My Journey Now")]), _vm._v(". I had no idea when I went to church that night, I would be singing in front of 800 people. That was a first step in a long journey of ministry for me. We are all on a mission from God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are all on a journey. While it has been difficult over the past several months and we don’t know for sure what the future holds, we do know Who holds the future. It’s been painful and we have shared the loss of loved ones and many things we once took for granted. Our hope must be in the One who called us and that He will help us go back to a future that is better than it may seem to be at this current moment in time. The only place we can start is where we are, and our hope must be that somehow, some way, God will show us the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What does “better” look like from where you are now? No matter what you have been through, good or bad, today is a different day. It’s a fresh start and His mercies are new!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("Through the Lord’s mercies we are not consumed, Because His compassions fail not. They are new every morning; Great is Your faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Lamentations 3:22–23.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The past is the past and today is new. His mercies are new and today can be a fresh start on the road back to better. While defining better can be difficult, it isn’t impossible . . . neither is it impossible to go back to better. Going back to better has three requirements:")]), _vm._v(" "), _c('ol', {
    staticClass: "number"
  }, [_c('li', [_vm._v("Know you have a purpose in life.")]), _vm._v(" "), _c('li', [_vm._v("Know your own personal purpose.")]), _vm._v(" "), _c('li', [_vm._v("Take action to fulfill your purpose.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You have purpose in your life. Let’s begin with discovering your personal purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is the purpose of your life? How much have you thought about that lately?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Do you have it written somewhere that you can read it at least weekly? You should!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why are you here? Not here reading this book, but why are you here on earth?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consider what God has to say about the topic . . . He created you in Christ Jesus for good works which He has already prepared for you to do. You know what that means? God has a plan for your life and good works for you to accomplish. Think about that for a minute . . . God, the one Who created everything, created you for a purpose! "), _c('i', [_vm._v("Beforehand")]), _vm._v(", God created good works for you to accomplish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("God made you and equipped you for a purpose. Can you imagine the good works He has planned for you to accomplish? He already had them on His mind when He made you. You are not an accident. God has already set you up for these good works. You don’t have to hope you have a purpose in life. God made you on purpose for a purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Have you ever heard someone say: "), _c('i', [_vm._v("I am on a mission from God!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s you! You can say that all day, every day. You are on a mission from God!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He has special work for you to do, and He set you up to be able to do it. The only way you can fail is if you don’t lean into it and do your part.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Prayer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Heavenly Father, thank you for creating me for good works that you pre-planned for me to accomplish. Help me to understand what you want me to do and help me to live my purpose in life with every ounce of strength that you give me.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Think/Act")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Think about good works you have already done in your life. This isn’t bragging. Give God glory for each one. It is He who gave you the strength and opportunity. Make a list of these somewhere, and then write a short prayer of thanks to God and commitment to do more with His help.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c29b33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chap01.vue
// module id = 84
// module chunks = 0